// Run record (CIO 2026-10-27): the backend saves every Screener run in full (strategy/screener_run_archive.py)
// and reports the outcome as `runArchive`. A failed save never fails the run, so the page must say so.
export type RunArchive = {
  status: "saved" | "failed" | "off";
  blob?: string | null;
  savedAtUtc?: string | null;
};

export function runArchiveLine(
  a: RunArchive | null | undefined,
): { text: string; tone: "neutral" | "warning" } | null {
  if (!a) return null; // older backend: say nothing rather than guess
  if (a.status === "saved") return { text: `Run saved · ${a.blob ?? ""}`, tone: "neutral" };
  if (a.status === "failed")
    return { text: "Run NOT saved: the record could not be written, so this run exists only in this tab", tone: "warning" };
  return { text: "Run saving is switched off", tone: "warning" };
}
